import { gql } from 'apollo-boost';

export const IMG_DELETE = gql`
  mutation ImageDelete($imgId: ID!) {
    image_delete(input: { id: $imgId }) {
      message
    }
  }
`;
